<template>
    <form-search-multiselect
        v-if="isForm"
        v-model="selectedProperties"
        :variant="variant"
        :options="propertyOptions"
        :error="error"
        :placeholder="placeholder"
        :label="label"
        :controlValue="controlValue"
        :hideSelectAll="hideSelectAll"
        @show="onControlShow"
        @hide="onControlHide"
        @shown="onControlShown"
        @hidden="onControlHidden"
    ></form-search-multiselect>
    <search-multiselect
        v-else
        v-model="selectedProperties"
        :variant="variant"
        :icon="['fas', 'hotel']"
        :options="propertyOptions"
        :placeholder="placeholder"
        :controlValue="controlValue"
        :hideSelectAll="hideSelectAll"
        @show="onControlShow"
        @hide="onControlHide"
        @shown="onControlShown"
        @hidden="onControlHidden"
    ></search-multiselect>
</template>

<script>
    import FormSearchMultiselect from '../form-search-multiselect/form-search-multiselect.vue';
    import SearchMultiselect from '../search-multiselect/search-multiselect.vue';

    export default {
        name: 'PropertiesSearchMultiselect',
        components: {
            FormSearchMultiselect,
            SearchMultiselect,
        },
        props: {
            value: {
                type: Array,
                default: () => [],
            },
            initialValue: {
                type: Array,
                default: null,
            },
            isForm: {
                type: Boolean,
                default: false,
            },
            properties: {
                type: Array,
                default: () => [],
            },
            variant: {
                type: String,
                default: '',
            },
            error: {
                type: String,
                default: null,
            },
            label: {
                type: String,
                default: null,
            },
            placeholder: {
                type: String,
                default: 'Properties'
            },
            controlValue: {
                type: String,
                default: 'Properties'
            },
            hideSelectAll: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            propertyOptions() {
                const initialPropertyIDs = new Set(
                    (this.initialValue || []).map(property => property.property_id)
                );
                const disabledPropertyIDs = new Set(
                    this.properties.filter(property => property.disabled).map(property => property.property_id)
                )
                return this.properties
                    .filter(property => {
                        return !disabledPropertyIDs.has(property.property_id) ||
                            initialPropertyIDs.has(property.property_id);
                    })
                    .map(property => ({
                        value: !!property.room_id
                            ? `${property.property_id}-${property.room_id}`
                            : `${property.property_id}`,
                        text: property.name,
                    }))
            },
            selectedProperties: {
                get: function () {
                    return this.value.map(
                        property => !!property.room_id
                            ? `${property.property_id}-${property.room_id}`
                            : `${property.property_id}`
                    )
                },
                set: function (selectedProperties) {
                    const value = selectedProperties.map(selectedProperty => {
                        const propertyID = this.getPropertyIDFromSelectedProperty(selectedProperty);
                        const roomID = this.getRoomIDFromSelectedProperty(selectedProperty)
                        const property = {property_id: propertyID};
                        if (roomID) {
                            property.room_id = roomID;
                        }
                        return property;
                    })
                    this.$emit('input', value);
                }
            }
        },
        methods: {
            getPropertyIDFromSelectedProperty(selectedProperty) {
                const [propertyID, _] = selectedProperty.split('-');
                return propertyID * 1;
            },
            getRoomIDFromSelectedProperty(selectedProperty) {
                const [_, roomID] = selectedProperty.split('-');
                return roomID * 1;
            },
            onControlShow(e) {
                this.$emit('show', e);
            },
            onControlHide(e) {
                this.$emit('hide', e);
            },
            onControlShown() {
                this.$emit('shown');
            },
            onControlHidden() {
                this.searchValue = '';
                this.$emit('hidden');
            },
        }
    }
</script>
